// styles.js
import styled from "styled-components";

const android = !!window.__ANTSMEETING_ENTRY__;
// Windows AntsDesk theme.rs tokens, scoped to the native bundle.
// 색상 테마 정의
export const colors = {
  primary: "#6366f1", // 더 부드러운 인디고
  primaryDark: "#4f46e5",
  primaryLight: "#a5b4fc",
  secondary: "#06b6d4", // 선명한 청록색
  secondaryDark: "#0891b2",
  secondaryLight: "#67e8f9",
  accent: "#f97316", // 밝은 오렌지
  danger: "#f43f5e", // 선명한 핑크계열 빨강
  dangerDark: "#e11d48",
  success: "#10b981", // 녹색
  dark: "#0f172a", // 더 깊은 네이비
  light: "#f8fafc",
  gray: "#64748b",
  grayLight: "#e2e8f0",
  grayDark: "#334155",
  background: "#f1f5f9",
  backgroundDark: "#e2e8f0",
  text: "#0f172a",
  textLight: "#64748b",
  white: "#ffffff",
  black: "#0f172a",
  overlay: "rgba(15, 23, 42, 0.8)",
  gradient: "linear-gradient(135deg, #6366f1, #06b6d4)",
  surface: android ? '#0f1a2e' : '#ffffff',
  ...(android ? { primary: '#67a2ff', primaryDark: '#2d7cff', secondary: '#43c282',
    secondaryDark: '#2b9e69', danger: '#ff6d7f', dangerDark: '#e85368', success: '#43c282',
    dark: '#0f1a2e', black: '#09111f', light: '#162238', gray: '#95a8cf', grayLight: '#263750',
    background: '#09111f', backgroundDark: '#1a293f', text: '#f7faff', textLight: '#95a8cf',
    overlay: 'rgba(9,17,31,.96)' } : {})
};
// FaceTalkStyle.js에 추가할 스타일드 컴포넌트
export const MediaSelectorOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.overlay};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(8px);
`;

export const MediaSelectorCard = styled.div`
  background-color: ${colors.surface};
  border-radius: 1rem;
  padding: 2rem;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  @media (max-width: 768px) {
    padding: 1.5rem;
    width: 85%;
  }
`;

export const MediaSelectorTitle = styled.h2`
  color: ${colors.text};
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
`;

export const MediaOptionContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

export const MediaOptionButton = styled.button`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 0.75rem;
  background-color: ${colors.light};
  border: 1px solid ${colors.grayLight};
  color: ${props => props.color || colors.primary};
  flex: 1;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &:hover {
    background-color: ${colors.backgroundDark};
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
`;

export const IconContainer = styled.div`
  background-color: ${props => `rgba(${props.color || '79, 70, 229'}, 0.1)`};
  border-radius: 50%;
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const OptionLabel = styled.span`
  font-weight: 500;
  font-size: 1rem;
`;

export const OptionDescription = styled.span`
  font-size: 0.875rem;
  color: ${colors.textLight};
  margin-top: 0.5rem;
`;
export const ModalContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  background-color: ${colors.background};
  color: ${colors.text};
  overflow: hidden;
`;

export const FlexColumn = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  min-height: 0;
`;

export const Header = styled.div`
  display: flex;
  height: 3rem;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${colors.grayLight};
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  background-color: ${colors.surface};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;

  @media (max-width: 768px) {
    height: 2.5rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: 768px) {
    gap: 0.25rem;

    & > span {
      display: none;
    }
  }
`;

export const Title = styled.h2`
  font-size: 1rem;
  font-weight: 600;
  color: ${colors.text};

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

export const ParticipantCount = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: ${colors.primary};
  background-color: ${colors.grayLight};
  padding: 0.25rem 0.5rem;
  border-radius: 1rem;
`;

export const ParticipantCountText = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
`;

export const MainContent = styled.div`
  flex: 1;
  min-height: 0;
  background-color: ${colors.background};
  position: relative;
  overflow: hidden;
`;

export const VideoGrid = styled.div`
  height: 100%;
  padding: 0.5rem;

  @media (max-width: 768px) {
    padding: 0.25rem;
  }
`;

export const Controls = styled.div`
  display: flex;
  height: 4rem;
  align-items: center;
  justify-content: center;
  gap: 0.95rem;
  border-top: 1px solid ${colors.grayLight};
  background-color: ${colors.surface};
  padding: 0 1rem;
  flex-shrink: 0;

  @media (max-width: 768px) {
    height: 3.5rem;
    gap: 0.75rem;
    padding: 0 0.5rem;
  }
`;

// 버튼 스타일 현대화
export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 9999px;
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  font-weight: 500;

  @media (max-width: 768px) {
    height: 2.25rem;
    width: 2.25rem;
  }

  &:disabled {
    opacity: 0.4;
    pointer-events: none;
  }
  
  ${(props) =>
    props.variant === "ghost" &&
    `
    background-color: transparent;
    color: ${colors.text};
    
    &:hover {
      background-color: rgba(99, 102, 241, 0.1);
      color: ${colors.primary};
      transform: translateY(-2px);
    }
    
    &:active {
      transform: translateY(0);
    }
  `}
  
  ${(props) =>
    props.variant === "secondary" &&
    `
    background-color: ${colors.secondary};
    color: ${colors.white};
    box-shadow: 0 4px 6px -1px rgba(6, 182, 212, 0.3), 0 2px 4px -2px rgba(6, 182, 212, 0.2);
    
    &:hover {
      background-color: ${colors.secondaryDark};
      transform: translateY(-2px);
      box-shadow: 0 8px 10px -3px rgba(6, 182, 212, 0.3), 0 4px 6px -4px rgba(6, 182, 212, 0.2);
    }
    
    &:active {
      transform: translateY(0);
    }
  `}
  
  ${(props) =>
    props.variant === "destructive" &&
    `
    background-color: ${colors.danger};
    color: ${colors.white};
    box-shadow: 0 4px 6px -1px rgba(244, 63, 94, 0.3), 0 2px 4px -2px rgba(244, 63, 94, 0.2);
    
    &:hover {
      background-color: ${colors.dangerDark};
      transform: translateY(-2px);
      box-shadow: 0 8px 10px -3px rgba(244, 63, 94, 0.3), 0 4px 6px -4px rgba(244, 63, 94, 0.2);
    }
    
    &:active {
      transform: translateY(0);
    }
  `}
`;

// 비디오 컨테이너 현대화
export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 1rem;
  background-color: ${colors.dark};
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: scale(1.01);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    border-radius: 0.5rem;
    box-shadow: none;

    &:hover {
      transform: none;
      box-shadow: none;
    }
  }
`;

// 비디오 플레이스홀더 개선
export const VideoPlaceholder = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-color: ${colors.dark};
  background-image: linear-gradient(135deg, rgba(99, 102, 241, 0.05) 25%, transparent 25%, 
                    transparent 50%, rgba(99, 102, 241, 0.05) 50%, 
                    rgba(99, 102, 241, 0.05) 75%, transparent 75%, transparent);
  background-size: 20px 20px;
`;


export const VideoFrame = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: ${colors.black};
  overflow: hidden;
`;

export const VideoImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

export const AudioLevel = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0.125rem;
  background-color: ${colors.secondary};
  transition: all 150ms;
`;

export const VideoInfo = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  padding: 0.75rem;
  padding-top: 2rem;
`;

export const VideoInfoContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const VideoInfoLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const VideoInfoRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const VideoName = styled.span`
  font-weight: 600;
  color: ${(props) => (props.inVideo ? colors.white : colors.text)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${(props) => (props.small ? "0.75rem" : "0.875rem")};
  text-shadow: ${(props) => (props.inVideo ? "0 1px 2px rgba(0, 0, 0, 0.5)" : "none")};
`;

export const Avatar = styled.div`
  position: relative;
  display: flex;
  height: ${(props) => (props.small ? "3rem" : "4rem")};
  width: ${(props) => (props.small ? "3rem" : "4rem")};
  border-radius: 9999px;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  background-color: ${colors.primary};
  color: ${colors.white};
  font-weight: 600;
  font-size: 1.25rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 2px solid ${colors.white};
`;

export const AvatarImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const Icon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.color || 'inherit'};
`;

export const ToolboxContainer = styled.div`
  position: absolute;
  bottom: 4rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.5rem;
  background-color: rgba(255, 255, 255, 0.95);
  padding: 0.75rem;
  border-radius: 1rem;
  z-index: 10;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border: 1px solid ${colors.grayLight};
`;

export const ToolboxButton = styled(Button)`
  background-color: ${colors.grayLight};
  color: ${colors.primary};
  
  &:hover {
    background-color: ${colors.primaryLight};
    color: ${colors.white};
    transform: translateY(-1px);
  }
`;

export const ParticipantDrawer = styled.div`
  position: fixed;
  top: 3rem;
  right: ${(props) => (props.isOpen ? "0" : "-300px")};
  width: 300px;
  height: calc(100vh - 7rem);
  background-color: ${colors.surface};
  border-left: 1px solid ${colors.grayLight};
  transition: right 0.3s ease;
  z-index: 20;
  overflow-y: auto;
  color: ${colors.text};
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    top: 2.5rem;
    width: 100%;
    right: ${(props) => (props.isOpen ? "0" : "-100%")};
    height: calc(100vh - 6rem);
  }
`;

export const ParticipantItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid ${colors.grayLight};
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${colors.background};
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

export const ParticipantInfo = styled.div`
  margin-left: 0.75rem;
  flex: 1;
`;

export const ParticipantActions = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid ${colors.grayLight};
  background-color: ${colors.primary};
  color: ${colors.white};
`;

// 아이콘들은 그대로 유지

export const XIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 6 6 18"></path>
    <path d="m6 6 12 12"></path>
  </svg>
);

export const MicIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"></path>
    <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
    <line x1="12" x2="12" y1="19" y2="22"></line>
  </svg>
);

export const MicOffIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="2" x2="22" y1="2" y2="22"></line>
    <path d="M18.89 13.23A7.12 7.12 0 0 0 19 12v-2"></path>
    <path d="M5 10v2a7 7 0 0 0 12 7"></path>
    <path d="M15 9.34V5a3 3 0 0 0-5.68-1.33"></path>
    <path d="M9 9v3a3 3 0 0 0 5.12 2.12"></path>
    <line x1="12" x2="12" y1="19" y2="22"></line>
  </svg>
);

export const VideoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m22 8-6 4 6 4V8Z"></path>
    <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
  </svg>
);

export const VideoOffIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="2" x2="22" y1="2" y2="22"></line>
    <path d="M10.66 6H14a2 2 0 0 1 2 2v2.34l1 1L22 8v8"></path>
    <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
  </svg>
);

export const Share2Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="18" cy="5" r="3"></circle>
    <circle cx="6" cy="12" r="3"></circle>
    <circle cx="18" cy="19" r="3"></circle>
    <line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line>
    <line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line>
  </svg>
);

export const PhoneOffIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path>
    <line x1="22" x2="2" y1="2" y2="22"></line>
  </svg>
);

export const UsersIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

export const Volume2Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
    <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
    <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
  </svg>
);

export const SettingsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

export const EmojiIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
    <line x1="9" x2="9.01" y1="9" y2="9"></line>
    <line x1="15" x2="15.01" y1="9" y2="9"></line>
  </svg>
);

export const HandIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"></path>
    <path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2"></path>
    <path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8"></path>
    <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"></path>
  </svg>
);

export const ChatIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </svg>
);

export const UserPlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <line x1="19" x2="19" y1="8" y2="14"></line>
    <line x1="22" x2="16" y1="11" y2="11"></line>
  </svg>
);